
























import {Component, Prop, Ref, Vue} from 'vue-property-decorator';
import {Icon, latLngBounds, Map, LatLngBounds} from 'leaflet';
import {LIcon, LMap, LMarker, LTileLayer} from 'vue2-leaflet';
import {Marker} from "@/components/Marker";
import {Location} from "@/read-model/Location";
import {calculateMapCenter} from "@/components/MapTools";

type D = Icon.Default & {
  _getIconUrl?: string;
};

delete (Icon.Default.prototype as D)._getIconUrl;

class LeafletMarker {
  private marker: Marker

  constructor(marker: Marker) {
    this.marker = marker
  }

  get group() {
    return this.marker.group
  }

  get latLng() {
    return [this.marker.location.lattitude, this.marker.location.longitude]
  }

  get location() {
    return this.marker.location
  }

  get icon() {
    return {
      url: require('../assets/' + this.marker.iconUrl) + `?${this.marker.id}`,
      scaledSize: {width: 62, height: 62},
      anchor: [42, 55],
    }
  }
}

@Component({components: {LMap, LTileLayer, LMarker, LIcon}})
export default class LeafletMap extends Vue {
  @Ref() readonly map!: { mapObject: Map }

  get mapObject() {
    return this.map.mapObject
  }

  @Prop({
    default: function () {
      return [52.2297, 21.0122]
    }
  }) center!: number[]

  @Prop({
    default: function () {
      return {leftOffset: 0, bottomOffset: 0}
    }
  }) viewportOffset!: { leftOffset: number; bottomOffset: number }

  @Prop({
    default: function () {
      return []
    }
  }) markers!: Marker[]

  maxBounds = latLngBounds([
    [this.center[0] + 0.25, this.center[1] - 0.45],
    [this.center[0] - 0.25, this.center[1] + 0.35]
  ])

  url = "https://{s}.tile.openstreetmap.fr/hot/{z}/{x}/{y}.png"
  attribution = '<a href="https://www.jawg.io" target="_blank">&copy; Jawg</a> - <a href="https://www.openstreetmap.org" target="_blank">&copy; OpenStreetMap</a>&nbsp;contributors'

  get leafletMarkers(): LeafletMarker[] {
    return this.markers.map(marker => new LeafletMarker(marker))
  }

  markerClicked(marker: LeafletMarker) {
    this.$emit('group-selected', marker.group)
    const api: Map | undefined = this.mapObject

    if (!api) {
      return
    }

    const bounds: LatLngBounds | null | undefined = api.getBounds()

    if (!bounds) {
      return
    }

    const northWest = new Location(bounds.getNorthEast().lat, bounds.getSouthWest().lng)
    const southEast = new Location(bounds.getSouthWest().lat, bounds.getNorthEast().lng)
    const newCenter = calculateMapCenter(this.viewportOffset, marker.location, northWest, southEast)
    api.panTo({'lat': newCenter.lattitude, lng: newCenter.longitude})
  }
}
